import { Component, ElementRef, OnInit,ViewChild ,AfterViewInit, Type} from '@angular/core';
import { EditorChangeContent, EditorChangeSelection } from 'ngx-quill';
import{QuestionManagementService} from "../../Services/question-management/question-management.service";
//import 'quill-emoji/dist/quill-emoji.js';
import { ImageHandler, Options } from 'ngx-quill-upload';
import { Output,EventEmitter,Input } from '@angular/core';
import Quill from 'quill';

// import BlotFormatter from 'quill-blot-formatter';

import { HttpClient, HttpParams,HttpHeaders } from '@angular/common/http';
;
import { HttpErrorHandlerService, HandleError } from '../../Services/config/http-error-handler.service';
import {BaseSvcService} from '../../Services/config/base-svc.service';
import { AppOfflineStore } from '../../app.offlineService';
import { HttpRequest, HttpEvent } from '@angular/common/http';
import { ToastrService } from "ngx-toastr";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { isNgTemplate } from '@angular/compiler';
import { MATHtest,latex,mathjax,emptylatex,emptymathjax,index,emptyindex } from '../../../assets/js/fullscreen';
import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import BlotFormatter, { Action, AlignAction, DeleteAction, ImageSpec, ResizeAction } from 'quill-blot-formatter';

import Parchment from "parchment";
//import {} from 'quill-image-rotate-module';
//import {} from 'quill-image-drop-and-paste'
//import {ImageResize} from 'quill-image-resize-module';
//Quill.register('modules/imageResize', ImageResize);
//import { ImageRotate } from "quill-image-rotate-module";

//Quill.register("modules/ImageRotate", ImageRotate);
// class PreserveWhiteSpace {
//   constructor(private Quill: any, private options: {}) {
//     Quill.container.style.whiteSpace = "pre-line";
//   }
// }
// Quill.register('modules/preserveWhiteSpace', PreserveWhiteSpace);

console.log(Quill);
const QuillBlockEmbed = (Quill as any).import('blots/block/embed');

class CustomImageSpec extends ImageSpec {
  getActions() {
      return [ResizeAction,AlignAction];
  }
}
class BlotSpec {
  formatter: BlotFormatter;

  constructor(formatter: BlotFormatter) {
    this.formatter = formatter;
  }

  init(): void {}



  getTargetElement(): HTMLElement | null {
    return null;
  }

  getOverlayElement(): HTMLElement | null {
    return this.getTargetElement();
  }

  setSelection(): void {
    this.formatter.quill.setSelection(null);
  }

  onHide() {}
}
export let latex1: string = 'latex';

Quill.register('modules/blotFormatter', BlotFormatter);
Quill.register('modules/imageHandler', ImageHandler);
Quill.register('MATHtest',MATHtest);

@Component({
  selector: 'app-quill-rte',
  templateUrl: './quill-rte.component.html',
  styleUrls: ['./quill-rte.component.css']
})




export class QuillRTEComponent implements OnInit {
  @Output() GetQuestionBodyContent: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetLatexBodyContent: EventEmitter<any> = new EventEmitter<any>();
  @Output() RemoveLatexBodyContent: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetAnswerChoiceContent: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetAnswerChoiceNoteContent: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetCommentboxContent: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetCommentboxContent1: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetLatexBodyContentchanges: EventEmitter<any> = new EventEmitter<any>();

  @Input() QuestionBodyget:any;
  @Input() Previewquestion:string;
  @Input() RTEFlag:string;
  Readonly:boolean=false;
  dirty:boolean=false;
  private handleError: HandleError;
  public url:string;
  public options;
  safehtmlStr:SafeHtml;
  editor:any;
  editorService: any;
  quill: any;



  constructor(private http: HttpClient,
    private appserv:AppOfflineStore,
    public dom:DomSanitizer,
    public httpErrorHandler: HttpErrorHandlerService,
    private config:BaseSvcService,
    public svc:QuestionManagementService,private toastr: ToastrService,private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document) {
      this.handleError = httpErrorHandler.createHandleError('HeroesService');
      this.url=this.config.activeURL;
      this.options=this.config._httpoption;
      //this.formatter=formatter;

    }



  test:any;
  currentlatex:any;
  ngOnInit(): void {
    // removetag();
    // if(this.RTEFlag=='AnswerChoiceNote'|| this.RTEFlag=='AnswerChoice'|| this.RTEFlag=='QuestionBody'){
   MATHtest();


    // }

    this.GetContent();
    console.log(this.RTEFlag,'RTEFlag');
    this.dirty=false;



   // console.log(this.QuestionBodyget,'QuestionBodyget');
//     var newstr = this.QuestionBodyget.replace(this.QuestionBodyget, "");
// console.log(newstr)



  }




 QuillConfiguration = {

  blotFormatter: {
    specs: [
      BlotSpec,
      CustomImageSpec
    ],
  } ,
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote'],
      [{'header': 1}, {'header': 2}],               // custom button values
      [{'list': 'ordered'}, {'list': 'bullet'}],
      [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
      [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
      [{'direction': 'rtl'}],                         // text direction
      [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      [{'color': []}, {'background': []}],          // dropdown with defaults from theme
      [{'font': ['sans-serif']}],
      [{'align': []}],
      ['clean'],                                       // remove formatting button
      ['link', 'image', 'video',]

    ],

    imageHandler: {
      upload: (file:any) => {
        return new Promise((resolve, reject):any => {

          if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
            if (file.size < 1000000) {
              var name = file.name.substr(0, file.name.lastIndexOf('.'));
              const formData: FormData = new FormData();
              formData.append('file', file);
              // const uploadData = new FormData();
              // uploadData.append('file', file, file.name);

              const promise=this.http.post(this.url+'/api/FileAPI/UploadFiles/'+1+"/"+name, formData).toPromise();
              return promise
                .then((result:any)=> {
                    resolve(result);
                })
                .catch(error => {
                  reject('Upload failed');
                  this.toastr.error('Upload failed');
                  console.error('Error:', error);
                });
            } else {
              reject('Size too large');
              this.toastr.error('Size too large');
            }
          } else {
            reject('Unsupported type');
            this.toastr.error('Unsupported type');

          }
        });
      },
      accepts: ['png', 'jpg', 'jpeg', 'jfif']
    }as Options,




  }

  QuillConfiguration1 = {
    "theme": "snow",
    "modules": {
        "toolbar": false
    }
  };






  blured = false
  focused = false

  created(event: any) {
    MATHtest();
    console.log('editor-created', event)
    this.dirty=false;
    // console.log(this.QuestionBodyget,'QuestionBodygetcreated')
  }

  ngmodel:string;
  autopopulate:boolean=false;
  quillcursorposition:any;
  content:any;
  changedEditor(event: EditorChangeContent | EditorChangeSelection) {
    //MATHtest();
    document.body.oncopy = function() { return false; }
    console.log('editor-change', event)
    this.editor=event.editor;
    this.autopopulate=false;
    if(event.event=='text-change'&&event.source=='user'){
      this.dirty=true;
      this.GetLatexBodyContentchanges.emit(this.dirty)
     }
     if(event.event=='text-change'&&event.source=='api'&&latex!=''){
      this.dirty=true;
      this.GetLatexBodyContentchanges.emit(this.dirty)
     }
    if(event.event=='text-change'){
      this.autopopulate=true;
      this.ngmodel=String(event.html);

      this.GetContent();
    }





    // if(event.event=='selection-change'){
    //     this.quillcursorposition=event.range?.index;
    // }
    // if(event.event=='selection-change'&&event.source=='silent'){
    // if(this.quillcursorposition){
    //   console.log(this.quillcursorposition,'Deletecursor')
    //   this.RemoveLatexBodyContent.emit(this.quillcursorposition);}else{
    //     console.log(888888, this.quillcursorposition)
    //   }
    // }
    // console.log(latex,'currentlatex');
  }



  GetContent(){
    if(this.RTEFlag=='QuestionBody'){
      if(this.autopopulate){
        this.GetQuestionBodyContent.emit(this.ngmodel);
        //getallcontent from quill editor
        //pass the content for tag below
      //   let list: any = {};
      //  list["latex"] = latex;
      //  list["mathjax"]=mathjax;
      //  list["cursor"]=index;
      // this.GetLatexBodyContent.emit(list);
      //   console.log(list);
      //   emptylatex();
      //   emptymathjax();
      //   emptyindex();
      //   this.quillcursorposition=null;

      //this.content=this.ngmodel;
      //let elements = document.getElementsByTagName('span');
      emptylatex();
      let UDTReason: any[] = [];
      const parser = new DOMParser();
      // convert html string into DOM
    const document = parser.parseFromString(this.ngmodel, "text/html");
      let elements = document.getElementsByClassName('ql-mathjax');
       for (let i = 0; i < elements.length; i++) {
           let list: any = {};
              list["latex"] = elements[i].getAttribute('data-value');

              list["mathjax"]=elements[i].innerHTML;
              console.log(elements[i].innerHTML);
              console.log(elements[i].getAttribute('data-value'));
              UDTReason.push(list);
            }
            this.GetLatexBodyContent.emit(UDTReason);
      }

      else{
        emptylatex();
        this.GetQuestionBodyContent.emit(this.QuestionBodyget);
        let UDTReason: any[] = [];
        const parser = new DOMParser();
        // convert html string into DOM
      const document = parser.parseFromString(this.QuestionBodyget, "text/html");
      let elements = document.getElementsByClassName('ql-mathjax');
       for (let i = 0; i < elements.length; i++) {
           let list: any = {};
              list["latex"] = elements[i].getAttribute('data-value');
              list["mathjax"]=elements[i].innerHTML;
              console.log(elements[i].innerHTML);
              console.log(elements[i].getAttribute('data-value'));
              UDTReason.push(list);
            }
            this.GetLatexBodyContent.emit(UDTReason);
      }
    }
    if(this.RTEFlag=='AnswerChoice'){
      if(this.autopopulate){
        emptylatex();
        this.GetAnswerChoiceContent.emit(this.ngmodel);
        let UDTReason: any[] = [];
        const parser = new DOMParser();
        // convert html string into DOM
      const document = parser.parseFromString(this.ngmodel, "text/html");
        let elements = document.getElementsByClassName('ql-mathjax');
       for (let i = 0; i < elements.length; i++) {
           let list: any = {};
              list["latex"] = elements[i].getAttribute('data-value');
              list["mathjax"]=elements[i].innerHTML;
              console.log(elements[i].innerHTML);
              console.log(elements[i].getAttribute('data-value'));
              UDTReason.push(list);
            }
            this.GetLatexBodyContent.emit(UDTReason);
      }
      else{
        emptylatex();
      this.GetAnswerChoiceContent.emit(this.QuestionBodyget);
      let UDTReason: any[] = [];
      const parser = new DOMParser();

// convert html string into DOM
      const document = parser.parseFromString(this.QuestionBodyget, "text/html");
      let elements = document.getElementsByClassName('ql-mathjax');

       for (let i = 0; i < elements.length; i++) {
           let list: any = {};
              list["latex"] = elements[i].getAttribute('data-value');
              list["mathjax"]=elements[i].innerHTML;
              console.log(elements[i].innerHTML);
              console.log(elements[i].getAttribute('data-value'));
              UDTReason.push(list);
            }
            this.GetLatexBodyContent.emit(UDTReason);
      }
    }
    if(this.RTEFlag=='AnswerChoiceNote'){
      emptylatex();
      if(this.autopopulate){
        this.GetAnswerChoiceNoteContent.emit(this.ngmodel);
        let UDTReason: any[] = [];
        const parser = new DOMParser();
        // convert html string into DOM
      const document = parser.parseFromString(this.ngmodel, "text/html");
        let elements = document.getElementsByClassName('ql-mathjax');
       for (let i = 0; i < elements.length; i++) {
           let list: any = {};
              list["latex"] = elements[i].getAttribute('data-value');
              list["mathjax"]=elements[i].innerHTML;
              console.log(elements[i].innerHTML);
              console.log(elements[i].getAttribute('data-value'));
              UDTReason.push(list);
            }
            this.GetLatexBodyContent.emit(UDTReason);
      }
      else{
        emptylatex();
      this.GetAnswerChoiceNoteContent.emit(this.QuestionBodyget);
      let UDTReason: any[] = [];
      const parser = new DOMParser();
      // convert html string into DOM
    const document = parser.parseFromString(this.QuestionBodyget, "text/html");
        let elements = document.getElementsByClassName('ql-mathjax');
       for (let i = 0; i < elements.length; i++) {
           let list: any = {};
              list["latex"] = elements[i].getAttribute('data-value');
              list["mathjax"]=elements[i].innerHTML;
              console.log(elements[i].innerHTML);
              console.log(elements[i].getAttribute('data-value'));
              UDTReason.push(list);
            }
            this.GetLatexBodyContent.emit(UDTReason);
      }
    }
    if(this.RTEFlag=='Commentbox'){
      this.GetCommentboxContent.emit(this.QuestionBodyget);
    }
    if(this.RTEFlag=='Submit for review'){
      this.GetCommentboxContent1.emit(this.QuestionBodyget);
    }

    console.log(this.QuestionBodyget,'QuestionBodyget');
  }
  focus($event: any) {
    //console.log('focus', $event)

    this.focused = true
    this.blured = false
  }

  blur($event: any) {

    //console.log('blur', $event)
    this.focused = false
    this.blured = true
  }

  click(data:any){

  this.editor.disable();

}

// Value:string
// quill_styles={

// this.Value=this.RTEFlag;

// }


  // blotFormatter: {
  //   // empty object for default behaviour.
  // }
  // Question:any;
  // QuestionBodyByQuestionId:any;
  // QuestionBodyset:string

  // ViewHTML(){
  //       this.svc.GetQuestionBodyByQuestionID({'QuestionID':'HIST_34354_ENG'}).subscribe((i:any)=> {
  //         this.Question=i;
  //         this.QuestionBodyByQuestionId=this.Question.SubjectExistsInd;
  //         this.QuestionBodyset=this.QuestionBodyByQuestionId[0].Question_Body_Text;
  //         this.safehtmlStr=this.dom.bypassSecurityTrustHtml(this.QuestionBodyset);
  //       },(e:any)=>{console.log(e)});

  //     }


      // AddQuestionBodyResponse:any

      // getFormattedContent(){

      //        console.log(this.QuestionBodyget,'htmlContent');

      //       let UDTQuestionlist = [];
      //           let list: any = {};
      //           list["Question_Body_Sequence_Number"] = 1;
      //           list["Question_Body_ID"] = null;
      //           list["Question_Body_Type_Code"] = 'Text';
      //           list["Question_File_Object_ID"] =null;
      //           list["Question_File_Name"] = null;
      //           list["Question_File_Type_Code"] = null;
      //           list["Question_Body_File_Location_Name"] = null;
      //           list["Question_Body_File_Image_Height"] = null;
      //           list["Question_Body_File_Image_Width"] = null;

      //           list["Question_Body_Text"] =this.QuestionBodyget;
      //           UDTQuestionlist.push(list);

      //       var InsertQuestion = {
      //         Question_Body_Text:this.QuestionBodyget,
      //         Question_ID:"HIST_34354_ENG",
      //         Question_Status_ID:4,
      //         UDTQuestionBody:UDTQuestionlist
      //       };
      //       this.svc.CreateOrModifyQuestionBody(InsertQuestion).subscribe((i:any)=> {
      //         console.log(i);
      //         this.AddQuestionBodyResponse=i;
      //   if(this.AddQuestionBodyResponse.Message=="Success")
      //   {
      //       this.toastr.success("insert");
      //   }
      //       },(e:any)=>{
      //         console.log(e)
      //       });
      //     }
      // }


  quillevent:any;
  value:boolean=false;
list:any
height:number
width:number
height1:number
width1:number
      getview(event:any){
        this.value=false;
        this.list=event.path

        //  for(let item of this.list){

        // if(item.className=='quill-upload-image'||item.nodeName=='IMG'){
        //   this.value=true;
        //   this.height=item.offsetHeight;
        //   this.width=item.offsetWidth;
        //   this.height1=item.offsetHeight;
        //   this.width1=item.offsetWidth;

        // }
        //  }



      }

      changepixel(){
       this.getheight();
       this.getwidth();
      }



      getheight(){


        for(let item of this.list){

          if(item.className=='ql-container ql-snow'){

            for(let value of item.children){
              if(value.className=='blot-formatter__overlay'){
                var name = value.attributes.style.nodeValue.substr(0, value.attributes.style.nodeValue.lastIndexOf('height'));
                value.attributes.style.nodeValue=name+"height:"+this.height+"px"+";";

              }
            }
          }
          if(item.className=='quill-upload-image'||item.nodeName=='IMG'){
            item.className=='quill-upload-image'
            this.value=true;
            item.height=this.height;

          }


           }

      }
      leftvalue:number;
      getwidth(){
        for(let item of this.list){
          if(item.className=='ql-container ql-snow'){

            for(let value of item.children){
              if(value.className=='blot-formatter__overlay'){
                var name = value.attributes.style.nodeValue.substr(0, value.attributes.style.nodeValue.lastIndexOf('width'));
                value.attributes.style.nodeValue=name+"width:"+this.width+"px"+";"+"height:"+this.height+"px"+";";
                var topalignment=value.attributes.style.nodeValue.substr(0, value.attributes.style.nodeValue.lastIndexOf('top'));
                var leftalignment=topalignment.split('left:').pop();
                var leftslice=value.attributes.style.nodeValue.substr(0, value.attributes.style.nodeValue.lastIndexOf('left'));
                var topslice=name.split('top:').pop();
                if(leftalignment!='15px'){
                  var leftpxvalue=leftalignment.substr(0, leftalignment.lastIndexOf('px'));
                  if(this.width1>this.width){
                    var left=this.width1-this.width;
                    this.width1=this.width;
                    var y: number = +leftpxvalue;
                    this.leftvalue=y+left;
                    value.attributes.style.nodeValue=leftslice+"left:"+this.leftvalue+"px"+";"+"top:"+topslice+";"+"width:"+this.width+"px"+";"+"height:"+this.height+"px"+";";
                  }
                  if(this.width1<this.width){
                    var left=this.width-this.width1;
                    this.width1=this.width;
                    this.leftvalue=leftpxvalue.replaceAll('"', '')-left;
                    value.attributes.style.nodeValue=leftslice+"left:"+this.leftvalue+"px"+";"+"top:"+topslice+";"+"width:"+this.width+"px"+";"+"height:"+this.height+"px"+";";
                  }

                }
              }
            }
          }
          if(item.className=='quill-upload-image'||item.nodeName=='IMG'){
            item.className=='quill-upload-image'
            this.value=true;
            //item.height=this.height;
            item.width=this.width
          }


           }

      }





}







